import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@components/Button';
import StatusDot from '@components/StatusDot';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';

const InfoRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
});

const Label = ({ children }) => (
    <Typography variant="body2" sx={{ color: 'var(--text-secondary)' }}>
        {children}
    </Typography>
);

const DomainCheckStatus = ({ status, statusLabel, lastCheckedAt, error, checking, onCheck, extraRows = [] }) => {
    const { t } = useTranslation();

    return (
        <>
            {onCheck ? (
                <Button
                    variant="outlined"
                    onClick={onCheck}
                    disabled={checking}
                    startIcon={checking ? <CircularProgress size={16} /> : null}
                    sx={{ alignSelf: 'flex-start' }}
                >
                    {checking ? t('MicrositesPage.checking') : t('MicrositesPage.checkStatus')}
                </Button>
            ) : null}

            {error ? (
                <Typography variant="caption" sx={{ color: 'var(--error-main)' }}>
                    {error}
                </Typography>
            ) : null}

            <InfoRow>
                <Label>{t('MicrositesPage.status')}</Label>
                <StatusDot status={status} />
                <Typography variant="body2">{statusLabel}</Typography>
            </InfoRow>
            {lastCheckedAt ? (
                <InfoRow>
                    <Label>{t('MicrositesPage.lastChecked')}</Label>
                    <Typography variant="body2">{new Date(lastCheckedAt).toLocaleString()}</Typography>
                </InfoRow>
            ) : null}
            {extraRows.map(row => (
                <InfoRow key={row.label}>
                    <Label>{row.label}</Label>
                    <Typography variant="body2">{row.value}</Typography>
                </InfoRow>
            ))}
        </>
    );
};

export default DomainCheckStatus;
